import dateFns from 'date-fns';
import { getRangeDates, DATE_UNIT } from '@/utils/date-helper';
import _ from 'lodash';
import { fiflboxApi } from '@/utils/api';

const state = {
  childCourses: {}
};

function getLastCourseOfYesterday(date) {
  const yesterdayDate = dateFns.format(dateFns.addDays(date, -1), 'YYYY-MM-DD');

  if (!state.childCourses[yesterdayDate]) {
    return null;
  }

  const lastCourseOfYesterdays = state.childCourses[yesterdayDate].filter(
    childCourse => {
      return !dateFns.isSameDay(
        dateFns.addMinutes(childCourse.dt, childCourse.duration),
        dateFns.addDays(date, -1)
      );
    }
  );

  return lastCourseOfYesterdays;
}

const getters = {
  getChildCourses: state => {
    return state.childCourses;
  },
  getChildCoursesByDates: state => dates => {
    return dates.map(date => {
      return state.childCourses[dateFns.format(date, 'YYYY-MM-DD')] || [];
    });
  },
  getChildCoursesWithOverlapsByDates: state => dates => {
    return dates.map(date => {
      let childCourses =
        state.childCourses[dateFns.format(date, 'YYYY-MM-DD')] || [];
      let lastCourseOfYesterdays = getLastCourseOfYesterday(date);

      if (lastCourseOfYesterdays) {
        childCourses = [...lastCourseOfYesterdays, ...childCourses];
      }

      return childCourses;
    });
  }
};

const actions = {
  async syncChildCourses({ commit }, range) {
    try {
      let { data } = await fiflboxApi.v2.getChildCourses({
        date_after: range.start.toDateFormat(),
        date_before: range.end.toDateFormat(),
        booking_count: true
      });
      const dates = getRangeDates(
        range.start,
        dateFns.endOfDay(range.end),
        DATE_UNIT.day
      );

      dates.forEach(date => {
        const dateFormat = date.toDateFormat();
        if (data[dateFormat]) {
          data[dateFormat] = data[dateFormat].sort((dateLeft, dateRight) =>
            dateFns.compareAsc(dateLeft.dt, dateRight.dt)
          );
        }
      });

      commit('setChildCourses', data);
    } catch (err) {
      console.log(err);
    }
  }
};

const mutations = {
  setChildCourses(state, childCourses) {
    state.childCourses = {
      ...childCourses
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
